<script>
    import { INSPECTION_ITEM_TYPE } from '@/constants';
    import CloseButton from '@/components/Modals/CloseButton.vue';

    const formatResponse = (response) => {
        if (Array.isArray(response)) return response.join(', ');
        if (response) return response;
        return '-';
    };

    const formatTitle = (item, $t) => ({
        [INSPECTION_ITEM_TYPE.INSPECTION]: () => $t('Checklist title'),
        [INSPECTION_ITEM_TYPE.PAGE]: () => $t('Page'),
        [INSPECTION_ITEM_TYPE.SECTION]: () => $t('Section'),
        [INSPECTION_ITEM_TYPE.CONDITIONAL]: () => $t('Query'),
        [INSPECTION_ITEM_TYPE.QUESTION]: () => $t('Query'),
    }[item.type]() || '-');

    const formatDescription = (item) => ({
        [INSPECTION_ITEM_TYPE.INSPECTION]: () => item.title || '-',
        [INSPECTION_ITEM_TYPE.PAGE]: () => item.title || '-',
        [INSPECTION_ITEM_TYPE.SECTION]: () => item.title || '-',
        [INSPECTION_ITEM_TYPE.CONDITIONAL]: () => ({
            description: item.parent.title || '-',
            answer: formatResponse(item.parent.response),
        }),
        [INSPECTION_ITEM_TYPE.QUESTION]: () => ({
            description: item.title || '-',
            answer: formatResponse(item.response),
        }),
    }[item.type]() || '-');

    export default {
        name: 'AutomaticInformPayloadModal',
        components: {
            CloseButton,
        },
        props: {
            payload: {
                type: Object,
                required: true,
            },
        },
        methods: {
            modalClosed() {
                this.$emit('close');
            },
            isEmptyPage(item) {
                return item.type === INSPECTION_ITEM_TYPE.PAGE && !item.title;
            },
        },
        computed: {
            questionTree() {
                const translate = (term) => this.$t(term);

                return this
                    .payload
                    .breadcrumb
                    .filter((item) => !this.isEmptyPage(item))
                    .reduce((acc, item) => {
                        const formattedItem = {
                            title: formatTitle(item, translate),
                            response: formatDescription(item),
                        };

                        if ([INSPECTION_ITEM_TYPE.CONDITIONAL, INSPECTION_ITEM_TYPE.QUESTION].includes(item.type)) {
                            return [
                                ...acc,
                                {
                                    title: formattedItem.title,
                                    response: formattedItem.response.description,
                                },
                                {
                                    title: this.$t('Answer'),
                                    response: formattedItem.response.answer,
                                },
                            ];
                        }

                        return [
                            ...acc,
                            formattedItem,
                        ];
                    }, []);
            },
        },
    };
</script>

<template>
    <modal @modal-close="modalClosed">
        <div class="modal-wrapper">
            <CloseButton @click="modalClosed"/>

            <div class="modal-content">
                <div v-for="item in questionTree" class="item" :key="item.uuid">
                    <h4>{{ item.title }}</h4>
                    <p>{{ item.response }}</p>
                </div>
            </div>
        </div>
    </modal>
</template>
